import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { initTimer, stopTimer } from '../../util/initTimer';
import { Form, Loading, Panel, DefaultButton, ContentHeader, Tabs } from '../../components';
import { AddressDetailForm, OperatorDetailForm, UserDetailForm } from '../userDetail';
import { usersActions } from '../../state/ducks/users';
import { authActions } from '../../state/ducks/auth';
import { agencyActions } from '../../state/ducks/agency';
import { TOAST_CONFIG } from "../../config/constants";

class UserOperatorEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'first',
      country: 'AR',
      dni: '',
      cuit: '',
      name: '',
      lastname: '',
      phoneNumber: '',
      email: '',
      province: '',
      location: '',
      city: '',
      address: '',
      zipCode: '',
      agency: '',
      rol: '',
      operators: '',
      listTabs: [],
    };
  }

  componentDidMount() {
    const {
      location,
      fetchCompanyTypes,
      getProvinces,
    } = this.props;
    stopTimer();
    initTimer(this.props);
    fetchCompanyTypes();
    getProvinces();
    this.handleCreateTabs();
  }

  handleCreateTabs = () => {
    const {
      view,
      dni,
      cuit,
      name,
      lastname,
      phoneNumber,
      email,
      country,
      province,
      location,
      city,
      address,
      zipCode,
      agency,
      rol,
      operators,
    } = this.state;

    const person = {
      dni,
      cuit,
      name,
      lastname,
      phoneNumber,
      email,
    };

    const operator = {
      agency,
      rol,
    };

    const fullAddress = {
      country,
      province,
      location,
      city,
      address,
      zipCode,
    };

    const {
      t, users: { loading },
      auth: { loading: loadingAuth, },
    } = this.props;

    let { children, nextView, prevView, submitText } = ''

    const listTabs = [
      {
        title: 'legalRepresentant',
        id: 't1',
        content: (
          <div className="pr-16px pl-16px pt-16px content-xl-center">
            <Form
              submitText={t('save')}
              nameButton="configButton"
              onSubmit={(e) => {}}
            >
              <UserDetailForm
                handleInputChange={this.handleInputChange}
                handlePhoneChange={this.handlePhoneChange}
                handleVerifyCuit ={this.handleVerifyCuit}
                person={person}
                editable
              />
            </Form>
          </div>
        ),
      },
      {
        title: 'agencyRol',
        id: 't2',
        content: (
          <div className="pr-16px pl-16px pt-16px content-xl-center">
            <Form
              submitText={t('save')}
              nameButton="configButton"
              onSubmit={(e) => {}}
            >
              <OperatorDetailForm
                handleInputChange={this.handleInputChange}
                operator={operator}
                editable
              />
            </Form>
          </div>
        ),
      },
      {
        title: 'detailAddress',
        id: 't3',
        content: (
          <div className="pr-16px pl-16px pt-16px content-xl-center">
            <Form
              submitText={t('save')}
              nameButton="configButton"
              onSubmit={(e) => {}}
            >
              <AddressDetailForm
                handleInputChange={this.handleInputChange}
                handlePhoneChange={this.handlePhoneChange}
                address={fullAddress}
                editable
              />
            </Form>
          </div>
        ),
      },
    ];
    this.setState({ listTabs });
  }

  callApiList = () => {
    // const { fetchCreateAgency } = this.props;
    // const {
    //   dni,
    //   cuit,
    //   name,
    //   lastname,
    //   phoneNumber,
    //   cuitCompany,
    //   companyType,
    //   nameCompany,
    //   iva,
    //   usernameCompany,
    //   phoneNumberCompany,
    //   city: { value: id_city },
    //   address,
    //   zipCode,
    // } = this.state;

    // fetchCreateAgency({
    //   data: {
    //     business_cuit: cuitCompany,
    //     business_name: nameCompany,
    //     email: usernameCompany,
    //     iva,
    //     phone_number: phoneNumberCompany,
    //
    //     address,
    //     id_city,
    //     zip_code: zipCode,
    //
    //     name: name,
    //     lastname: lastname,
    //     document_number: dni,
    //     document_number_aux: cuit,
    //     agent_phone_number: phoneNumber
    //   },
    //   callback: () => {
    //
    //   }
    // });
    alert('Datos editados')
  }

  handleInputChange = ({ target: { value: targetValue, name } }) => {
    stopTimer();
    initTimer(this.props);
    this.setState({
      [name]: targetValue,
    });
  };

  handleVerifyCuit = (ev) => {
    this.setState({
      dni: ev.target.value.substr(2, 8)
        .replace(/^0+/, ''),
    });
  };

  onSubmit = (event) => {
    stopTimer();
    initTimer(this.props);
    event.preventDefault();
    this.callApiList()
  };

  handleChangeView = (event, view = 'first') => {
    event.preventDefault();
    const { t, showMessage } = this.props;
    const {
      dni,
      cuit,
      name,
      lastname,
      phoneNumber,
      email,
      province,
      location,
      city,
      address,
      zipCode,
      agency,
      rol,
    } = this.state;
    if (dni === ''
      || cuit === ''
      || name === ''
      || lastname === ''
      || phoneNumber === ''
      || email === ''
      || province === ''
      || location === ''
      || city === ''
      || address === ''
      || zipCode === ''
      || agency === ''
      || rol === '') {
      showMessage({
        message: t('allRequiredFields'),
        config: TOAST_CONFIG.ERROR,
      });
      return;
    }
    this.setState({ view });
  }

  render() {
    const { listTabs } = this.state;
    const { t, handleReturn } = this.props;
    return (
      <div>
        {/*{(loading || loadingAuth) && <Loading />}*/}
        <ContentHeader
          headingText={(
            <DefaultButton
              name={t('goBack')}
              onClick={handleReturn}
            />
          )}
        >
          <Tabs listTabs={listTabs} />
        </ContentHeader>
      </div>
    );
  }
}


UserOperatorEdit.propTypes = {
  t: PropTypes.func.isRequired,
  users: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({}),
  ]).isRequired,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = ({ users, auth, agency }) => (
  {
    users,
    auth,
    agency,
  }
);
export default compose(
  connect(mapStateToProps, {
    ...usersActions,
    ...authActions,
    ...agencyActions,
  }),
  withNamespaces(),
)(UserOperatorEdit);
